import { render, staticRenderFns } from "./jobs.vue?vue&type=template&id=1d8704dc&scoped=true&"
import script from "./jobs.vue?vue&type=script&lang=js&"
export * from "./jobs.vue?vue&type=script&lang=js&"
import style0 from "./jobs.vue?vue&type=style&index=0&id=1d8704dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8704dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\2000HuiTian\\huitianadmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d8704dc')) {
      api.createRecord('1d8704dc', component.options)
    } else {
      api.reload('1d8704dc', component.options)
    }
    module.hot.accept("./jobs.vue?vue&type=template&id=1d8704dc&scoped=true&", function () {
      api.rerender('1d8704dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bussiness/jobs.vue"
export default component.exports